import { render, staticRenderFns } from "./ProductCardProfessional.vue?vue&type=template&id=5265fac0&scoped=true&"
import script from "./ProductCardProfessional.vue?vue&type=script&lang=ts&"
export * from "./ProductCardProfessional.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265fac0",
  null
  
)

export default component.exports